// Generated by ReScript, PLEASE EDIT WITH CARE

import * as JsxRuntime from "react/jsx-runtime";
import * as BsCssJs$PrezzeeRibbon from "../../../bindings/BsCss/BsCssJs.bs.js";
import * as CircleIcon$PrezzeeRibbon from "../CircleIcon/CircleIcon.bs.js";
import * as ThemeContext$PrezzeeRibbon from "../../../context/ThemeContext/ThemeContext.bs.js";

function socialIcon(theme) {
  var match = theme.components;
  var footer = match.footer;
  return BsCssJs$PrezzeeRibbon.style([
              BsCssJs$PrezzeeRibbon.color(footer.iconColor),
              BsCssJs$PrezzeeRibbon.backgroundColor(footer.iconBackgroundColor),
              BsCssJs$PrezzeeRibbon.fontSize(BsCssJs$PrezzeeRibbon.px(12)),
              BsCssJs$PrezzeeRibbon.important(BsCssJs$PrezzeeRibbon.display("inlineFlex")),
              BsCssJs$PrezzeeRibbon.marginRight(BsCssJs$PrezzeeRibbon.px(6))
            ]);
}

var Styles = {
  socialIcon: socialIcon
};

function Footer__SocialIcon(props) {
  var theme = ThemeContext$PrezzeeRibbon.useTheme(undefined);
  return JsxRuntime.jsx(CircleIcon$PrezzeeRibbon.make, {
              children: props.children,
              className: socialIcon(theme)
            });
}

var make = Footer__SocialIcon;

export {
  Styles ,
  make ,
}
/* react/jsx-runtime Not a pure module */
